import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";

export default function CTASection() {
  return (
    <Box component="section" sx={{ py: 12, position: "relative", overflow: "hidden" }}>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(135deg, hsl(var(--primary)) 0%, hsl(var(--primary)) 50%, hsl(var(--wellness)) 100%)"
        }}
      />
      <Box sx={{ position: "absolute", top: 0, right: 0, width: 384, height: 384, bgcolor: "rgba(255,255,255,0.05)", borderRadius: "50%", filter: "blur(64px)" }} />
      <Box sx={{ position: "absolute", bottom: 0, left: 0, width: 384, height: 384, bgcolor: "rgba(255,255,255,0.05)", borderRadius: "50%", filter: "blur(64px)" }} />

      <Box className="container-custom" sx={{ position: "relative", zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: "center", maxWidth: 768, margin: "0 auto" }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.875rem", md: "2.25rem", lg: "3rem" },
              fontWeight: 800,
              color: "#fff",
              mb: 3,
              lineHeight: 1.15
            }}
          >
            Ready to Transform
            <Box component="span" sx={{ display: "block" }}>
              Your Healthcare Experience?
            </Box>
          </Typography>

          <Typography
            sx={{
              fontSize: "1.125rem",
              color: "rgba(255,255,255,0.8)",
              mb: 5,
              maxWidth: 672,
              mx: "auto"
            }}
          >
            Join thousands of families who have discovered a better way to manage their health.
            Start your personalized wellness journey today.
          </Typography>

          <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: "center", justifyContent: "center", gap: 2 }}>
            <Button
              component={Link}
              to="/signup"
              size="large"
              variant="contained"
              sx={{
                bgcolor: "#fff",
                color: "primary.main",
                minWidth: 200,
                boxShadow: "var(--shadow-elevated)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.9)" }
              }}
              endIcon={<ArrowForwardRoundedIcon sx={{ transition: "transform 200ms" }} />}
            >
              Get Started Free
            </Button>

            <Button
              component={Link}
              to="/contact"
              size="large"
              variant="outlined"
              sx={{
                minWidth: 200,
                borderColor: "rgba(255,255,255,0.3)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(255,255,255,0.1)", borderColor: "rgba(255,255,255,0.3)" }
              }}
              startIcon={<PhoneRoundedIcon sx={{ fontSize: 18 }} />}
            >
              Schedule a Call
            </Button>
          </Box>

          <Box sx={{ mt: 6, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", gap: 4, color: "rgba(255,255,255,0.6)", fontSize: 14 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CalendarMonthRoundedIcon sx={{ fontSize: 16 }} />
              <span>No commitment required</span>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#4ade80" }} />
              <span>Free health assessment</span>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#4ade80" }} />
              <span>Cancel anytime</span>
            </Box>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
}
